(function($) {
  $(document).ready(function(){
    
    var elem = document.querySelector('.boxgrid');
    var msnry = new Masonry( elem, {
      itemSelector: '.workgrid'
    });
    $('.slickinaja').slick({
      infinite: true,
      speed: 500,
      arrow: false,
      autoplay: true,
      autoplaySpeed: 4000,
      fade: true,
      cssEase: 'linear'
    });
    $('a.work').click(function(e){
      e.preventDefault();
      $('#listwork').removeClass('senddown');
      msnry.layout();
      $('a.back').delay(400).removeClass('invisit');
    });
    
    $('a.back').click(function(e){
      e.preventDefault();
      $('a.back').addClass('invisit').delay(400);
      $('#listwork').addClass('senddown');
    });
    
    
    /*var resizeID = 0;
    var tgt = $('.data-news');
     sync_elem_height(tgt);

     $(window).resize(function(){
       clearTimeout(resizeID);
       resizeID = setTimeout(function(){
         sync_elem_height(tgt);
       }, 250);
       same_height();
     });
    same_height();
    $('.slideInfo').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows:true
    });
    $('.bg-corousel').slick({
      dots: true, 
      infinite: true,
      speed: 500,
      autoplay:true,
      arrows:true
    }); */
    
  });
  /*
  function sync_elem_height(elems){
   elems.css('height', null);
   elems.css('height', 'auto');
   var max_h = 0;
   elems.each(function(){
     var tg_h = $(this).outerHeight();
     if(tg_h>max_h){
       max_h = tg_h;
     }
   }); 
   elems.css('height', max_h+10+'px');
  }
  
  function same_height(){
    $('.box-news-next').css('height', $('.box-news').height());
    $('.img-kop-news').css('height', $('.box-news').outerHeight());
  }
  */
})(jQuery);